import { getMessages } from '../../../../../../store/constants';

export const MY_WORK_TITLE = getMessages().getText('assigned_to_me.title');

export const MY_WORK_SETTINGS_IMPORT = getMessages().getText('assigned_to_me.settings.menu.import');
export const MY_WORK_SETTINGS_OPEN = getMessages().getText('assigned_to_me.settings.menu.open');
export const MY_WORK_SETTINGS_BACKGROUND = getMessages().getText('assigned_to_me.settings.menu.background');
